import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { API } from 'network/api';
import { StakeholderType } from 'types/common';
import { handleAxiosError } from 'utils/helpers';

type VerifyStakeholderPayload = {
  stakeholderId: string;
  stakeholderType?: StakeholderType;
  dataVerifiedStatus?: boolean;
  reason?: string;
};

const useMutateVerifyStakeholder = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data: VerifyStakeholderPayload) =>
      API.post('/stakeholder/verify', data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['stakeholder-data'],
      });
      message.success('Stakeholder data reviewed sucessfully');
    },
    onError: (error) => {
      handleAxiosError(error, 'Failed to verify stakeholder. Please try again');
    },
  });

  return mutation;
};

export default useMutateVerifyStakeholder;
